import React from "react";
import { Scrollbars } from "react-custom-scrollbars";
import ReactTable from "react-table";
import checkboxHOC from "react-table/lib/hoc/selectTable";
import Aux from "../../../system/containers/Aux";
import PageHeader from "../../../system/components/PageHeader";
import { WrappedTable } from "../../../system/containers/Table";
import moment from "moment";
import { Button, Modal, ModalHeader, ModalFooter, ModalBody } from "reactstrap";
import { change } from "redux-form";

const CheckboxTable = checkboxHOC(ReactTable);

class List extends React.Component {
  state = {
    modal: false,
    reviewId: null,
    reviews: [],
    ifLoaded: false,
  };

  columns = [
    {
      accessor: "id",
      Header: "Review ID",
    },
    {
      accessor: "customer",
      Header: "Name:",
    },
    {
      accessor: "published",
      Header: "Date Published",
    },
    {
      accessor: "rating",
      Header: "Rating",
    },
    {
      accessor: "title",
      Header: "Title",
    },
    {
      accessor: "review",
      Header: "Review",
      Cell: (props) => (
        <div>
          <Button
            outline
            size="sm"
            onClick={() => this.reviewModal(props.original.id)}
          >
            View review
          </Button>

          {/* <Modal isOpen={this.state.modal} toggle={this.toggle}>
                        <ModalHeader toggle={this.toggle}>{props.original.title}</ModalHeader>
                        <ModalBody>
                        {props.original.review}
                    </ModalBody>
                     <ModalFooter>
                          <Button color="secondary" onClick={this.toggle}>Close</Button>
        </ModalFooter>
      </Modal> */}
        </div>
      ),
    },
  ];

  componentDidMount() {}

  componentWillReceiveProps(nextProps) {
    if (nextProps.initialValues) {
      const reviewArr = [];
      nextProps.selected.forEach((key) => reviewArr.push({ id: key }));

      if (nextProps.formValues) {
        if (!this.state.isLoaded) {
          nextProps.initialValues.reviews.length > 0 &&
          this.props.defaultSelected(
            nextProps.initialValues.reviews.map((review) => review.id)
          );
          this.setState({
            isLoaded: true,
          });
        }
        if (nextProps.formValues.reviews !== reviewArr) {
          this.setState({
            reviews: reviewArr,
          });
          this.props.dispatch(
            change(this.props.formType, "reviews", reviewArr)
          );
        }
      }
    }
  }

  reviewModal = (review) => {
    this.setState({ modal: true, reviewId: review });
  };
  toggleReview = (key) => {
    this.setState({
      reviewArr: [...this.state.reviewArr, { id: key }],
    });
  };

  toggle = () => this.setState({ modal: !this.state.modal });

  render() {
    const { data, checkboxProps } = this.props;

    return (
      <Aux>
        <PageHeader title="Reviews" />
        {console.log("select", this.props.selected)}
        <CheckboxTable
          ref={(r) => (this.checkboxTable = r)}
          data={data}
          toggleSelection={(key, shift, row) =>
            this.toggleReview(key, shift, row)
          }
          keyField="id"
          showPaginationBottom
          filterable
          columns={this.columns}
          defaultPageSize={20}
          style={{
            minHeight: "100vh",
          }}
          className="-striped -highlight"
          {...checkboxProps}
        />

        {this.state.modal && (
          <Modal isOpen={this.state.modal} toggle={this.toggle}>
            <ModalHeader toggle={this.toggle}>
              {this.props.data[this.state.reviewId].title}
            </ModalHeader>
            <ModalBody>{this.props.data[this.state.reviewId].review}</ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={this.toggle}>
                Close
              </Button>
            </ModalFooter>
          </Modal>
        )}
      </Aux>
    );
  }
}

const WrapTable = WrappedTable(List);

export default WrapTable;



// WEBPACK FOOTER //
// ./src/containers/Deals/components/ReviewsTable.jsx